import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { EbmResourceConfigurationRecord } from './types';

export function getEbmResourceConfigurations(): Promise<EbmResourceConfigurationRecord[]> {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/resource-configurations`);
}
